import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css"; // Core Swiper styles
import { Pagination, EffectFade, Navigation } from "swiper/modules";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocalizedLink } from "../../hooks/useLocalizedLink";

function BannerOne() {
  const { t } = useTranslation();
  const getLocalizedPath = useLocalizedLink();
  const swiperRef = useRef(null);

  useEffect(() => {
    // Function to add animation classes
    const animationProperties = () => {
      document.querySelectorAll("[data-ani]").forEach((element) => {
        const animationName = element.getAttribute("data-ani");
        element.classList.add(animationName);
      });

      document.querySelectorAll("[data-ani-delay]").forEach((element) => {
        const delayTime = element.getAttribute("data-ani-delay");
        element.style.animationDelay = delayTime;
      });
    };

    animationProperties();
  }, []);

  // Event handler for custom navigation arrows
  const handleSliderNavigation = (direction) => {
    if (swiperRef.current && swiperRef.current.swiper) {
      const swiper = swiperRef.current.swiper;
      if (direction === "prev") {
        swiper.slidePrev();
      } else {
        swiper.slideNext();
      }
    }
  };

  return (
    <div className="th-hero-wrapper hero-1" id="hero">
      <Swiper
        ref={swiperRef}
        modules={[Navigation, Pagination, EffectFade]} // Initialize necessary modules
        effect="fade" // Use fade effect
        loop={true} // Enable loop
        speed={1000}
        pagination={{
          el: ".swiper-pagination", // Custom pagination container
          clickable: true, // Enable clickable pagination
        }}
        navigation={{
          nextEl: ".slider-next", // Custom next button
          prevEl: ".slider-prev", // Custom prev button
        }}
        className="th-slider hero-slider-1"
        id="heroSlide1"
      >
        <div className="swiper-wrapper">
          {/* Image Slide 1 */}
          <SwiperSlide>
            <div className="hero-inner">
              <div
                className="th-hero-bg"
                style={{
                  backgroundImage:
                    "url(/assets/img/yurt-fotograf/yemekhane/5.jpg)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
                role="img"
                aria-label="Haseki Sultan Kız Öğrenci Yurdu - Yemekhane"
                title="Haseki Sultan Kız Öğrenci Yurdu - Yemekhane"
              ></div>
              <div className="container">
                <div className="hero-style1">
                  {/* <span
                    className="sub-title style1"
                    data-ani="slideinup"
                    data-ani-delay="0.2s"
                    style={{ color: "#ffffff" }}
                  >
                    {t("home.banner.slide1.subTitle")}
                  </span> */}
                  <h1
                    className="hero-title"
                    data-ani="slideinup"
                    data-ani-delay="0.4s"
                    style={{ color: "#ffffff" }}
                  >
                    {t("home.banner.slide1.title")}
                  </h1>
                  <div
                    className="btn-group"
                    data-ani="slideinup"
                    data-ani-delay="0.6s"
                  >
                    <Link
                      to={getLocalizedPath("/contact")}
                      className="th-btn th-icon"
                    >
                      {t("nav.onlineRegistration")}
                    </Link>
                    <Link
                      to={getLocalizedPath("/service")}
                      className="th-btn style2 th-icon"
                      style={{
                        backgroundColor: "#808080",
                        borderColor: "#808080",
                        color: "#fff",
                      }}
                    >
                      {t("nav.services")}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
          {/* Image Slide 2 */}
          <SwiperSlide>
            <div className="hero-inner">
              <div
                className="th-hero-bg"
                style={{
                  backgroundImage:
                    "url(/assets/img/yurt-fotograf/3-kisilik-on-cephe-106/4.jpg)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
                role="img"
                aria-label="Haseki Sultan Kız Öğrenci Yurdu - 3 Kişilik Oda"
                title="Haseki Sultan Kız Öğrenci Yurdu - 3 Kişilik Oda"
              ></div>
              <div className="container">
                <div className="hero-style1">
                  <span
                    className="sub-title style1"
                    data-ani="slideinup"
                    data-ani-delay="0.2s"
                    style={{ color: "#ffffff" }}
                  >
                    {t("home.banner.slide2.subTitle")}
                  </span>
                  <h1
                    className="hero-title"
                    data-ani="slideinup"
                    data-ani-delay="0.4s"
                    style={{ color: "#ffffff" }}
                  >
                    {t("home.banner.slide2.title")}
                  </h1>
                  <div
                    className="btn-group"
                    data-ani="slideinup"
                    data-ani-delay="0.6s"
                  >
                    <Link
                      to={getLocalizedPath("/contact")}
                      className="th-btn th-icon"
                    >
                      {t("nav.onlineRegistration")}
                    </Link>
                    <Link
                      to={getLocalizedPath("/about")}
                      className="th-btn style2 th-icon"
                    >
                      {t("nav.about")}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
          {/* Image Slide 3 */}
          <SwiperSlide>
            <div className="hero-inner">
              <div
                className="th-hero-bg"
                style={{
                  backgroundImage: "url(/assets/img/yurt-fotograf/teras/7.jpg)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
                role="img"
                aria-label="Haseki Sultan Kız Öğrenci Yurdu - Teras"
                title="Haseki Sultan Kız Öğrenci Yurdu - Teras"
              ></div>
              <div className="container">
                <div className="hero-style1">
                  <span
                    className="sub-title style1"
                    data-ani="slideinup"
                    data-ani-delay="0.2s"
                    style={{ color: "#ffffff" }}
                  >
                    {t("home.banner.slide3.subTitle")}
                  </span>
                  <h1
                    className="hero-title"
                    data-ani="slideinup"
                    data-ani-delay="0.4s"
                    style={{ color: "#ffffff" }}
                  >
                    {t("home.banner.slide3.title")}
                  </h1>
                  <div
                    className="btn-group"
                    data-ani="slideinup"
                    data-ani-delay="0.6s"
                  >
                    <Link
                      to={getLocalizedPath("/contact")}
                      className="th-btn th-icon"
                    >
                      {t("nav.contact")}
                    </Link>
                    <Link
                      to={getLocalizedPath("/service")}
                      className="th-btn style2 th-icon"
                    >
                      {t("nav.services")}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </div>
        <div className="th-swiper-custom">
          <button
            className="slider-arrow slider-prev"
            onClick={() => handleSliderNavigation("prev")}
          >
            <img src="/assets/img/icon/right-arrow.svg" alt="Prev" />
          </button>
          <div className="swiper-pagination" /> {/* Pagination container */}
          <button
            className="slider-arrow slider-next"
            onClick={() => handleSliderNavigation("next")}
          >
            <img src="/assets/img/icon/left-arrow.svg" alt="Next" />
          </button>
        </div>
      </Swiper>
    </div>
  );
}

export default BannerOne;
